// extracted by mini-css-extract-plugin
export default {"left_box":"index_left_box_s0VoE","dbox":"index_dbox_SjxvZ","adBox":"index_adBox_S3Vd6"};